import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";
import { Timeout } from "@formant/core/model/Timeout";
import { IIceMode } from "@formant/rtc-client/models/IIceMode";

import { operateStore } from "../../../stores";
import * as styles from "./WebRTCConnectionStatus.scss";

export interface IWebRTCConnectionStatusProps {}

@observer
export class WebRTCConnectionStatus extends Component<IWebRTCConnectionStatusProps> {
    @observable
    private iceMode?: IIceMode;
    @observable
    private getIceModeInterval?: Timeout;

    public componentDidMount() {
        this.getIceModeInterval = setInterval(() => {
            const { session } = operateStore;
            this.iceMode = session?.iceMode;
        }, 1 * duration.second);
    }

    public componentWillUnmount() {
        const { getIceModeInterval } = this;
        if (getIceModeInterval) {
            clearInterval(getIceModeInterval);
        }
    }

    public render() {
        return (
            !!this.iceMode && (
                <div
                    className={classnames(styles["webrtc-connection-status"])}
                    data-tooltip={
                        this.iceMode === "TURN"
                            ? "Teleop traffic is being routed through a TURN cloud relay. You may experience degraded performance."
                            : `You have a direct P2P connection (${this.iceMode}) with your device.`
                    }
                >
                    <div className={styles.indicator} />
                    <div className={styles.label}>
                        {this.iceMode === "TURN" ? "RELAY" : "P2P"}
                    </div>
                </div>
            )
        );
    }
}
